import { BrandHighlight } from '../BrandHighlight';
import Logo from '../Logo';
import { Locale } from '../../i18n/types';

interface Props {
  motto: string;
  hero: Locale['hero'];
  onLoreClick: () => void;
}

export default function LandingHero({ motto, hero, onLoreClick }: Props) {
  return (
    <div className="mb-4 flex-no-shrink">
      <button
        className="broomwagon-hero-badge"
        onClick={onLoreClick}
      >
        <Logo size={14} color="currentColor" />
        <span>Broom Wagon</span>
      </button>
      <div className="hero-header-layout">
        <h1 className="text-white fw-bold mb-3 hero-title">
          {motto}
        </h1>
      </div>
      <p className="hero-subtitle">
        <BrandHighlight text={hero.desc} />
      </p>
      <div className="d-flex flex-column gap-2 mb-4">
        <div className="d-flex align-items-center gap-2 hero-feature-item">
          <i className="bi bi-lightning-charge-fill" style={{ color: '#0d6efd' }}></i>
          <span>{hero.tagline}</span>
        </div>
        <div className="d-flex align-items-center gap-2 hero-feature-item" style={{ color: '#dee2e6' }}>
          <i className="bi bi-check-circle-fill" style={{ color: '#198754' }}></i>
          <span className="fw-medium">{hero.free}</span>
        </div>
      </div>
    </div>
  );
}
